import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/brand";
import { ArrowUpRight } from "lucide-react";

export default function AboutUs() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[#E7DECF] text-[#0A0A0A] py-32 md:py-48 px-6 md:px-12 overflow-hidden">
      <div className="mx-auto max-w-[1500px] grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.4, ease: [0.76, 0, 0.24, 1] }}
          className="md:col-span-7 relative"
        >
          <div className="relative aspect-[4/5] md:aspect-[5/6] overflow-hidden">
            <img
              src={ASSETS.team}
              alt="Watson Group Team"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 overline text-white/90 backdrop-blur-sm bg-black/20 px-3 py-1.5 rounded-full">
              The Team · 2026
            </div>
          </div>
        </motion.div>

        {/* Copy */}
        <div className="md:col-span-5 md:pl-8">
          <p className="overline text-[#8C8273] mb-6">About Us</p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight mb-8"
          >
            What we <em className="text-[#8C8273]">stand for.</em>
          </motion.h2>

          <div className="space-y-5 text-[#3F3B36] text-base md:text-lg leading-relaxed max-w-md">
            <p>
              Led by experienced real estate professional Angela Watson (DRE 02010115), the Watson Group at LPT Realty brings over a decade of trusted real estate expertise to California's Central Valley.
            </p>
            <p>
              Specializing in Turlock, Modesto, Denair, and surrounding areas, the group leverages powerful digital marketing and elite negotiation skills to protect our clients' bottom lines. Backed by an exceptional track record, our listings sell with an incredible average of over 100% of the original asking price.
            </p>
            <p>
              We guide buyers and sellers through every step of escrow with clear communication and deep local insight. Whether buying your first home or selling a cherished property, the Watson Group delivers top-dollar results and dedicated service.
            </p>
          </div>

          <Link
            to="/agents"
            data-testid="about-meet-agents-button"
            className="group mt-10 inline-flex items-center gap-3 border border-[#0A0A0A]/40 hover:border-[#0A0A0A] rounded-full pl-6 pr-2 py-2 text-[12px] tracking-[0.25em] uppercase transition-all"
          >
            <span>Meet the Agents</span>
            <span className="w-9 h-9 rounded-full bg-[#0A0A0A] text-[#F4EFE6] flex items-center justify-center transition-transform group-hover:rotate-45">
              <ArrowUpRight size={16} />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
